import styles from "./Casino.module.css";
// import TabNavigator from "../../../components/tabNavigator";

export default function CasinoHeading({ name, rules, roundId, placedBetCount = 0, activeTab = "game", onTabChange, onRulesClick }) {
  const handleTabChange = (index, tab) => {
    if (onTabChange) {
      // Map index to string: 0 = "game", 1 = "placedBet"
      const tabName = index === 0 ? "game" : "placedBet";
      onTabChange(tabName);
    }
  };

  const handleRulesClick = () => {
    if (onRulesClick) {
      onRulesClick();
    }
  };

  const tabs = [
    {
      label: 'MARKET',
      href: '#market'
    },
    {
      label: 'OPEN BETS',
      href: '#open-bets',
      badge: placedBetCount > 0 ? placedBetCount.toString() : '0'
    }
  ];

  // Convert string activeTab to index: "game" = 0, "placedBet" = 1
  const activeTabIndex = activeTab === "placedBet" ? 1 : 0;

  return (
    <>
      <div className={styles.videoHeader}>
        <span className={styles.headerText}>
          {name}
          {/* <span className={styles.smallText} onClick={handleRulesClick} style={{ cursor: 'pointer' }}> Rules</span> */}
        </span>
        <span className={styles.RoundId}>Round ID: {roundId}</span>
      </div>

      {/* <TabNavigator tabs={tabs} defaultActiveTab={activeTabIndex} onTabChange={handleTabChange} /> */}

    </>
  );
}